import type { LocaleCode } from "../types/locale-code";

import { getLocaleMetadata } from "../registry/locale-registry";
import { isValidIrlPostcode } from "./irl/validation/irl-postcode";
import { nanpPostalCodePattern } from "./nanp-postal-code-pattern";

function isPostalCodeFormatValidForLocale(
  value: string,
  localeCode: LocaleCode,
): boolean {
  const { iso3166Alpha2Lower } = getLocaleMetadata(localeCode).country;
  const trimmedValue = value.trim();

  if (iso3166Alpha2Lower === "ie") {
    return isValidIrlPostcode(trimmedValue);
  }

  return nanpPostalCodePattern.test(trimmedValue);
}

export { isPostalCodeFormatValidForLocale };
